import { Routes } from '@angular/router';
import { appPaths } from './app-routes';
import { authPaths, authRoutes } from './features/auth/shared/auth-routes';
import { userPaths } from './features/user/shared/user-routes';
import { profilePaths } from './features/profile/shared/profile-routes';
import { benefitsPaths } from './features/benefit/shared/benefit-routes';
import { sighuPaths } from './features/sighu/shared/sighu-routes';
import { certificatePaths } from './features/certificates/shared/certificate-routes';
import { galleryPaths } from './features/gallery/pages/shared/gallery-routes';
import { notificationPaths } from './features/notification/pages/shared/notificacion-routes';
import { diningPaths } from './features/dining/shared/dining-routes';
import { Error404PageComponent } from './shared/pages/error404-page/error404-page.component';

export const APP_ROUTES: Routes = [
    {
        path: appPaths.home,
        redirectTo: authRoutes.logIn,
        pathMatch: 'full',
    },
    {
        path: authPaths.base,
        loadChildren: () => import('./features/auth/auth.routes').then(m => m.AUTH_ROUTES),
    },
    {
        path: userPaths.user,
        loadChildren: () => import('./features/user/user.routes').then(m => m.USER_ROUTES),
    },
    {
        path: profilePaths.base,
        loadChildren: () => import('./features/profile/profile.routes').then(m => m.PROFILE_ROUTES),
    },
    {
        path: benefitsPaths.base,
        loadChildren: () => import('./features/benefit/benefits.routes').then(m => m.BENEFIT_ROUTES),
    },
    {
        path: sighuPaths.base,
        loadChildren: () => import('./features/sighu/sighu.routes').then(m => m.SIGHU_ROUTES),
    },
    {
        path: certificatePaths.base,
        loadChildren: () => import('./features/certificates/certificates.routes').then(m => m.CERTIFICATE_ROUTES),
    },
    {
        path: galleryPaths.base,
        loadChildren: () => import('./features/gallery/gallery.routes').then(m => m.GALLERY_ROUTES),
    },
    {
        path: notificationPaths.base,
        loadChildren: () => import('./features/notification/notificacion.routes').then(m => m.NOTIFICATION_ROUTES),
    },
    {
        path: diningPaths.base,
        loadChildren: () => import('./features/dining/dining.routes').then(m => m.DINING_ROUTES),
    },
    {
        path: '404',
        component: Error404PageComponent,
    },
    {
        path: '**',
        redirectTo: '404',
    },
];